import React, {memo, useCallback, useState, useMemo} from "react"
import {PasswordContainer} from "../../../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../../../components/Settings/SettingsPageContainer"
import {useRPC} from "../../../../../../hooks/rpc"
import {useMessage} from "../../../../../../hooks/message"
import {SpeedTestModel} from "../../../../../../types/network"
import {SettingReadOnlyRowComponent} from "../../../../../../components/Settings/SettingReadOnlyRowComponent"
import {useDispatch} from "react-redux"
import {changeBusyAction} from "../../../../../../store/ui/actions"

export const SpeedTestScreen = memo(function SpeedTestScreen() {
    const {failure} = useMessage()
    const [rpc] = useRPC()
    const dispatch = useDispatch()
    const [speedTestResult, setSpeedTestResult] = useState<SpeedTestModel>(null)
    
    const startTest = useCallback(() => {
        dispatch(changeBusyAction(true))
        rpc.SendSpeedTest()
            .then(data => {
                setSpeedTestResult(data)
                dispatch(changeBusyAction(false))
            })
            .catch(failure)
            .finally(() => {
                dispatch(changeBusyAction(false))
            })
    }, [failure, dispatch, rpc])
    const buttons = useMemo(
        () => [
            {
                text: "Hız Testini Başlat",
                className: "blue",
                onClick: startTest
            }
        ],
        [startTest]
    )
    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                className="service-edit"
                backUrl={"/settings/advanced-settings/test/network"}
            >
                <div className="content-divider">
                    <div className="content-wrapper">
                        <SettingReadOnlyRowComponent
                            title="Server Name"
                            value={speedTestResult?.server_name || "unknown"}
                        />
                        <SettingReadOnlyRowComponent title="Ping" value={speedTestResult?.ping || "unknown"} />
                        <SettingReadOnlyRowComponent
                            title="External IP"
                            value={speedTestResult?.external_ip || "unknown"}
                        />
                        <SettingReadOnlyRowComponent
                            title="Internal IP"
                            value={speedTestResult?.internal_ip || "unknown"}
                        />
                        <SettingReadOnlyRowComponent
                            title="Download Speed"
                            value={speedTestResult?.download_speed || "unknown"}
                        />
                        <SettingReadOnlyRowComponent
                            title="Upload Speed"
                            value={speedTestResult?.upload_speed || "unknown"}
                        />
                        <SettingReadOnlyRowComponent title="ISP" value={speedTestResult?.isp || "unknown"} />
                    </div>
                    <div className="content-wrapper"></div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
